'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._CardActions = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _withExternalPropsCard = require('../withExternalPropsCard');

var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);

var _CardActionsStyled = require('./styles/CardActionsStyled');

var _externalPropTypes = require('../externalPropTypes');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = _externalPropTypes.externalPropTypes;
var defaultProps = _externalPropTypes.externalDefaultProps;

var _CardActions = exports._CardActions = function _CardActions(_ref) {
  var children = _ref.children,
      externalProps = _ref.externalProps;
  return _react2.default.createElement(_CardActionsStyled.CardActionsStyled, {
    size: externalProps.size
  }, children);
};

_CardActions.displayName = 'CardActions';
exports.default = (0, _withExternalPropsCard2.default)(_CardActions);
_CardActions.propTypes = propTypes;
_CardActions.defaultProps = defaultProps;